import { FormControlLabel, styled } from '@mui/material';

export const FullWidthControl = styled(FormControlLabel, {
  shouldForwardProp: (prop) => prop !== 'isSelected',
})(({ theme }) => ({
  position: 'relative',
  width: '100%',
  padding: 0,

  '.MuiRadio-root': {
    position: 'absolute',
    right: '100%',
    marginRight: theme.spacing(3),
  },

  '.MuiFormControlLabel-label': {
    width: '100%',
  },
}));
